module.exports = __webpack_public_path__ + "static/logo-04@2x.d1f34d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/company_images/logo-04@2x.png
// module id = 830
// module chunks = 168707334958949